import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
    SEARCH_WORD,
    SEARCH_WORD_HIGHLIGHT,
    SEARCH_LAYER,
    SEARCH_LIST_INSERT,
    SEARCH_POPULAR_LIST_INSERT,
    SEARCH_AUTO_LIST_INSERT,
    SEARCH_LIST_FOCUS_CLEAR,
} from '../../libs/reducer';
import { ga4_AdView } from 'common/libs/googleTagManager';

const SearchBar = ({ onSearch }) => {
    const {
        searchWord,
        searchLayer,
        searchList,
        popularList,
        autoList,
        searchLayerTab,
        searchLayerTabView,
        searchKeywordAdv,
    } = useSelector((state) => state.search);
    const [viewAdvText, setViewAdvText] = useState(false);

    const dispatch = useDispatch();
    const serchInput = useRef();
    const timeout = useRef(null);
    // eslint-disable-next-line
    const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g;

    let newWord = '';
    if (searchWord && searchWord.match(regExp)) {
        newWord = unescape(searchWord);
    }
    if (searchWord && !searchWord.match(regExp)) {
        newWord = searchWord;
    }

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);

        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, []);

    useEffect(() => {
        if (searchKeywordAdv) {
            setViewAdvText(true);

            // 검색광고 노출 태그
            ga4_AdView(searchKeywordAdv);
            // ua_AdView(searchKeywordAdv);
            // uaEventView(
            //     searchKeywordAdv.mall_name + '_' + searchKeywordAdv.idx_b_manager,
            //     searchKeywordAdv.nm_ad,
            //     searchKeywordAdv.ad_id,
            //     'null_null'
            // )
        }
    }, [searchKeywordAdv]);

    const searchLayerControl = useCallback((data) => {
        dispatch({
            type: SEARCH_LAYER,
            data: data,
        });
    }, []);

    const escFunction = useCallback((event) => {
        if (!event) return;
        if (event.keyCode === 27) searchLayerControl(false);
    }, []);

    const onChangeText = useCallback(
        (e) => {
            dispatch({
                type: SEARCH_WORD,
                data: e.target.value,
            });
            if (!searchLayer) {
                dispatch({
                    type: SEARCH_LAYER,
                    data: true,
                });
            }
            dispatch({
                type: SEARCH_LIST_FOCUS_CLEAR,
            });
            getAutoComplete(e.target.value);
        },
        [searchLayer],
    );

    const getAutoComplete = async (word) => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(async () => {
            const url = `${process.env.REACT_APP_API_URL}/front/v3/search/autoComplete?query=${word}`;
            try {
                const data = await axios.get(url);

                dispatch({
                    type: SEARCH_WORD_HIGHLIGHT,
                    data: word,
                });
                dispatch({
                    type: SEARCH_AUTO_LIST_INSERT,
                    data: data.data?.result || [],
                });
            } catch (e) {
                console.log(e);
            }
        }, 150);
    };

    const keyPressed = useCallback((e) => {
        if (e.key === 'Enter') {
            onSearch(newWord);
            searchLayerControl(false);
            return;
        }
        escFunction();
    });

    const onLayer = useCallback(() => {
        if (searchLayer) return false;
        searchLayerControl(true);
    });

    const onFocusInput = useCallback(() => {
        if (viewAdvText) {
            setViewAdvText(false);
        }
    }, [viewAdvText]);

    const tabKeyEvent = () => (e) => {
        let list = [];
        let insertList = '';
        if (searchLayerTab === 'latest') {
            list = [...searchList];
            insertList = SEARCH_LIST_INSERT;
            if (!searchLayerTabView.latest) {
                return;
            }
        } else if (searchLayerTab === 'popular') {
            list = [...popularList];
            insertList = SEARCH_POPULAR_LIST_INSERT;
        } else if (searchLayerTab === 'auto') {
            list = [...autoList];
            insertList = SEARCH_AUTO_LIST_INSERT;
            if (!searchLayerTabView.auto) {
                return;
            }
        } else {
            return;
        }
        if (list.length === 0) return; // 리스트 없으면 실행안함
        if (!searchLayer) return; // 레이어 없으면 실행안함

        const focusIndex = list.findIndex((v) => v.focus);
        let last = false;
        let searchText = '';
        let clone = [...list];

        if (e.key === 'Tab' || e.keyCode === 38 || e.keyCode === 40) {
            if (focusIndex > -1) {
                // 리스트 목록중 focus가 이미있음
                if (list.length - 1 === focusIndex && !e.shiftKey && e.keyCode !== 38) {
                    // 리스트의 마지막
                    clone = clone.map((v) => ({ ...v, focus: false }));
                    searchText = '';
                    last = true;
                    if (searchLayerTab === 'popular') {
                        serchInput.current.focus();
                        searchLayerControl(false);
                        e.preventDefault();
                    }
                } else if (focusIndex === 0 && (e.shiftKey || e.keyCode === 38)) {
                    // 리스트의 처음
                    clone = clone.map((v) => ({ ...v, focus: false }));
                    searchText = '';
                    searchLayerControl(false);
                } else {
                    // 리스트 순회
                    if (e.shiftKey || e.keyCode === 38) {
                        clone = clone.map((v, i) => {
                            return { ...v, focus: i === focusIndex - 1 ? true : false };
                        });
                        searchText = list[focusIndex - 1].s;
                    } else {
                        clone = clone.map((v, i) => {
                            return { ...v, focus: i === focusIndex + 1 ? true : false };
                        });
                        searchText = list[focusIndex + 1].s;
                        if (!searchText){
                            searchText = list[focusIndex + 1].key
                        }
                    }
                }
            } else {
                // 처음 tab
                if (e.shiftKey || e.keyCode === 38) {
                    clone[list.length - 1].focus = true;
                    searchText = list[list.length - 1].s;
                } else {
                    clone[0].focus = true;
                    searchText = list[focusIndex + 1].s;
                    if (!searchText){
                        searchText = list[focusIndex + 1].key
                    }
                }
            }
            dispatch({
                type: insertList,
                data: clone,
            });
            dispatch({
                type: SEARCH_WORD,
                data: searchText,
            });
            if (!last) e.preventDefault();
        }
    };

    return (
        <div className="serch_layout">
            <input
                className="search_input"
                type="text"
                autoComplete="off"
                value={searchWord && searchWord.match(regExp) ? unescape(searchWord) : searchWord}
                onChange={onChangeText}
                onKeyPress={keyPressed}
                onClick={onLayer}
                onKeyDown={tabKeyEvent()}
                ref={serchInput}
                tabIndex="1"
                placeholder={viewAdvText ? searchKeywordAdv.ment_keyword : ''}
                onFocus={onFocusInput}
            />
            <button
                className="search_button"
                onClick={() => onSearch(searchWord, viewAdvText ? searchKeywordAdv.lnk_ad : false)}
                tabIndex="2"
            >
                <span className="icon-search1" />
            </button>
        </div>
    );
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/header/component/search/searchBar.js